module.exports = __webpack_public_path__ + "img/IMG_8981.00adee16.jpg";